/**
 * Strips a possible leading $ and any commas from a string and then attempts to parse the result
 * @param {String} value raw value from user input
 * @returns {number} parsed value
 */
var parseNumber = function parseNumber(value) {
  var cleanValue = value.replace(/[,]|\s/g, "").replace(/^([-])?[$]/, "$1");
  if (cleanValue.match(/^[-]?\d+(\.\d+)?$/)) {
    return parseFloat(cleanValue);
  }
  return NaN;
};
export default parseNumber;